var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemovePhoto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 3.66688V13.001C11.6667 13.3546 11.5262 13.6938 11.2761 13.9438C11.0261 14.1939 10.687 14.3344 10.3333 14.3344H3.66667C3.31304 14.3344 2.97391 14.1939 2.72386 13.9438C2.47381 13.6938 2.33333 13.3546 2.33333 13.001V3.66688M1 3.66688H13M4.33333 3.66688V2.33344C4.33333 1.97979 4.47381 1.64062 4.72386 1.39056C4.97391 1.14049 5.31304 1 5.66667 1H8.33333C8.68696 1 9.02609 1.14049 9.27614 1.39056C9.52619 1.64062 9.66667 1.97979 9.66667 2.33344V3.66688",
    stroke: "black",
    strokeOpacity: 0.698039,
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovePhoto);
export default __webpack_public_path__ + "static/media/remove-photo.823ba228a088696d1581c28917be70ce.svg";
export { ForwardRef as ReactComponent };